import { render, staticRenderFns } from "./Dados.vue?vue&type=template&id=7918daf7&scoped=true&"
import script from "./Dados.vue?vue&type=script&lang=js&"
export * from "./Dados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7918daf7",
  null
  
)

export default component.exports